export const STATS_STATUS = {
  NOT_ASKED: "NOT_ASKED",
  LOADING: "LOADING",
  LOAD_DONE: "LOAD_DONE",
  LOAD_ERROR: "LOAD_ERROR"
};

export const ACTIVITY_ACTIONS = {
  OPENED: "Opened",
  UPDATED: "Updated",
  REPROCESSED_REGISTRIES: "ReprocessedRegistries",
  REJECTED: "Rejected",
  CONFIRMED: "Confirmed"
};
